import { render } from "./BaggingDetailModal.vue?vue&type=template&id=55210ca2"
import script from "./BaggingDetailModal.vue?vue&type=script&lang=js"
export * from "./BaggingDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__